module.exports = __webpack_public_path__ + "static/media/msg.61e6b426.svg";